"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAddChildProps = exports.AddChildPropsProvider = void 0;
var _react = require("react");
const AddChildPropsContext = /*#__PURE__*/(0, _react.createContext)(null);
const AddChildPropsProvider = exports.AddChildPropsProvider = AddChildPropsContext.Provider;
const useAddChildProps = () => (0, _react.useContext)(AddChildPropsContext);
exports.useAddChildProps = useAddChildProps;